import { INVENTORY_STOCK_DIRECTION } from "../../../../utils/inventory"
import { ACTION_TYPES, Actions } from "../actions/types"
import { stateHandler } from "./handler"
import { InitialState } from "./types"

const INITIAL_STATE: InitialState = {
    isLoading: false,
    isLoaded: false,
    isFetching: false,

    listing: [],

    id: "",
    name: "",
    prefix: "",
    direction: INVENTORY_STOCK_DIRECTION.IN,
    includeContact: false,
    colorCode: "",
    statuses: [],
    emailTemplates: [],
    documentTemplates: [],
}

export const reducer = (state = INITIAL_STATE, action: Actions) => {
    const handler = stateHandler(state)

    switch (action.type) {
    case ACTION_TYPES.FETCH_LISTING:
        return handler.fetchListing()
    case ACTION_TYPES.FETCH_LISTING_SUCCESS:
        return handler.fetchListingSuccess(action.payload)
    case ACTION_TYPES.SET_FROM_LISTING:
        return handler.setFromListing(action.payload)
    case ACTION_TYPES.FETCH_SUCCESS:
        return handler.fetchSuccess(action.payload)
    default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/stockDocumentDefinition/reducers/reducer.ts